import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a6194d499f1da00141ffeae_1784817540427_3be1526e/peoplecore/src/app/page.tsx");
